export interface Villa {
  id: string;
  url: string;
  domain: string;
  title: string | null;
  image: string | null;
  addedAt: string;
  addedAtFormatted: string;
  status: VillaStatus;
  pinned: boolean;
  phone: string | null;
  comment: string | null;
  price: number | null;
  priceFormatted: string | null;
  originalMessageId: string;
}

export type VillaStatus = 'new' | 'contacted' | 'visited' | 'shortlisted' | 'archived';

export interface VillasResponse {
  villas: Villa[];
  count: number;
  archivedCount?: number;
  title?: string;
}

export const STATUS_LABELS: Record<VillaStatus, string> = {
  new: 'Новая',
  contacted: 'Написали',
  visited: 'Просмотрена',
  shortlisted: 'Отобрана',
  archived: 'Архив',
};

export const STATUS_COLORS: Record<VillaStatus, string> = {
  new: 'var(--tg-theme-hint-color, #999)',
  contacted: 'var(--tg-theme-link-color, #3390ec)',
  visited: 'var(--tg-theme-secondary-bg-color, #eff1f5)',
  shortlisted: '#4caf50',
  archived: 'var(--tg-theme-hint-color, #999)',
};
